import './App.css';

import Login from './Login';
import Dashboard from './Dashboard';
import Comunicati from './Comunicati';
import Iniziative from './Iniziative';
import Tributi from './Tributi';
import Scadenzario from './Scadenzario';
import Rassegna from './Rassegna';
import Pagamenti from './Pagamenti';
import Personalizzato from './Personalizzato';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { DashboardStatsProvider } from './DashboardStatsContext';

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/" replace />;
}

function App() {
  return (
    <DashboardStatsProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/comunicati" element={
              <ProtectedRoute>
                <Comunicati />
              </ProtectedRoute>
            } />
            <Route path="/iniziative" element={
              <ProtectedRoute>
                <Iniziative />
              </ProtectedRoute>
            } />
            <Route path="/tributi" element={
              <ProtectedRoute>
                <Tributi />
              </ProtectedRoute>
            } />
            <Route path="/scadenzario" element={
              <ProtectedRoute>
                <Scadenzario />
              </ProtectedRoute>
            } />
            <Route path="/rassegna" element={
              <ProtectedRoute>
                <Rassegna />
              </ProtectedRoute>
            } />
            <Route path="/pagamenti" element={
              <ProtectedRoute>
                <Pagamenti />
              </ProtectedRoute>
            } />
            <Route path="/personalizzato" element={<ProtectedRoute><Personalizzato /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </Router>
    </DashboardStatsProvider>
  );
}

export default App;
